import * as React from "react";
const LiverSVG = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 146.24 92.85"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #e59fa1;\n        fill-rule: evenodd;\n        stroke: #000;\n        stroke-miterlimit: 1.82;\n        stroke-width: 1.95px;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g id="g2902">
        <g id="g2517">
          <path
            id="path2519"
            className="cls-1"
            d="M143.57,5.52c-6.19-2.68-25.64-.34-36.73-.77-11.69-.45-24.52-2.45-39.3-3.34-10.93-.65-26.13-.7-36.98.77-14.95,2.02-18.65,7.58-23.89,14.38C2.48,22.03,1.45,29.97,1.03,38.91c-.55,11.82,3.29,19.51,3.6,27.99.36,10.01-4.43,17.38-1.03,23.11,1.57,2.65,6.43,1.63,9.5,1.8,5.67.31,11.63-1.54,16.69-4.11,5.24-2.66,9.83-10.25,15.41-12.07,4.54-1.49,11.35,1.89,15.92.51,5.61-1.69,11.62-7.33,15.92-11.3,3.7-3.41,10.56-12.4,12.33-12.84,3.28-.81,16.62.48,22.86-1.8,6.15-2.25,10.46-6.74,15.15-11.3,2.75-2.68,3.85-7.43,6.42-10.27,2.67-2.95,7.25-6.7,8.99-10.27,1.29-2.65,2.97-5.09,2.31-7.96-.33-1.42-.21-4.3-1.54-4.88Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default LiverSVG;
